/**
 * function que hace un match de dos objetos,
 * /!\ modifica/actualiza el primer objeto /!\ con el segundo: es como un deep Object.assign
 *
 * No permite borrar campos, solo actualiza el valor, entonces para borrar un
 * - string: "", ej: match({a:'mi cadena'}, {a:''})
 * - object, array, number, boolean: null, ej: match({a:['mi cadena']}, {a:null})
 *
 * @param {object} original el objeto que se va sobreescribir
 * @param {object} data el objeto que sobreescribe
 */

export function match(original = {}, data = {}) {
  const keys = Object.keys(data);
  keys.forEach(key => {
    if (isObjectNotNull(original[key]) && isObjectNotNull(data[key])) {
      if (Array.isArray(original[key]) !== Array.isArray(data[key])) {
        throw new Error(
          `match: Ojo los campos "${key}" son distintos, el original es un ${
            Array.isArray(original[key]) ? '"array"' : '"object"'
          } y el nuevo es un ${Array.isArray(data[key]) ? '"array"' : '"object"'}.`
        );
      }
      match(original[key], data[key]);
      return;
    }
    original[key] = data[key];
  });
}

function isObjectNotNull(obj) {
  return typeof obj === 'object' && obj !== null;
}
